export const API_KEY = "c3bfa4bdb28d9cfa882313ad43f7ba6a";
export const BASE_URL = "https://api.themoviedb.org/3/";
export const IMG_BASE_URL = "http://image.tmdb.org/t/p/w500/";
export const ANON_PROFILE =
  "https://www.pngitem.com/pimgs/m/524-5246388_anonymous-user-hd-png-download.png";
export const MOVIE_CLAPPER =
  "https://clipartix.com/wp-content/uploads/2016/06/Movie-reel-gallery-for-blank-film-strip-clip-art-image-image.jpg";
